import BaseClient, { Response } from './Client';

export interface Result {
  available: boolean;
}

export interface Client {
  isUrlAvailable: (url: string) => Response<Result>;
}

export class VanityClient extends BaseClient implements Client {
  public isUrlAvailable = (url: string): Response<Result> =>
    this.callWwsApi(`${this.getWwsHost(true)}/wedding-website/is-url-available?slug=${encodeURIComponent(url)}`);
}
